<template>
    <div class="mb-2">
        <div class="pl-2 pr-2"><h5>{{transEdit('temp.vacancies')}}</h5></div>
        <template v-if="absences.length > 0">
            <div v-for="absence in absences" class="border rounded p-1 mt-1 pl-1 pr-1 ml-2 pl-2">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="flex " style="width: 17%;"><span class="">
                        <a :href="part.show_therapist_route + '/' + absence.therapist.id"> {{absence.therapist.user.name}}</a></span>
                    </div>
                    <div class="flex" style="width: 19%;">
                        <span class="">
                        <a :href="part.show_company_route + '/' + absence.location.primary_company.id"> {{absence.location.primary_company.name}}</a>
                        </span>
                    </div>
                    <div class="flex" style="width: 19%;">
                        <span v-if="absence.substitute"><a :href="part.show_therapist_route + '/' + absence.substitute.id">{{absence.substitute.user.name}}</a></span>
                        <span v-else>{{transEdit('temp.no-temp-has-accepted')}}</span>
                    </div>
                    <div class="flex" style="width: 21%;">
                        {{getFormattedDate(absence.absence_start)}} - {{getFormattedDate(absence.absence_end)}}
                    </div>
                    <div class="flex" style="width: 19%;">
                        <a :href="part.show_locations_route + '/' + absence.location.id"> {{absence.location.address}}</a>
                    </div>
                    <div class="flex-shrink-1 text-right" style="width: 5%;"><a :href="'/absences/' + absence.id"><i class="fa fa-search"></i> </a></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="pl-2 pr-2">
                {{transEdit('temp.vacancies.missing')}}
            </div>
        </template>
        <hr>
    </div>

</template>

<script>
    export default {
        props: ['part'],
        name: "AdminDashAbsencesPanel",
        data: function () {
            return {
                absences: [],
            };
        },
        methods: {
            getFormattedDate: function(date) {
                let _date = new moment(date);
                return _date.format('YYYY-MM-DD');
            },
            getDescriptor: function(type_id) {
                return descriptorArray[type_id - 1];
            },
        },
        mounted: function () {
            let self = this;
            axios.get(this.part.route_refresh)
                .then(function (response) {
                    self.absences = response.data.absences;
                })
                .catch(function (error) {
                });
        }
    }
</script>

<style scoped>

</style>
